/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.cms
 * 
 * This directive recompiles bound html for cms content if we want to include an ng-click in the content.
 */

clickableCmsContentDirective.$inject = ['$compile'];
function clickableCmsContentDirective($compile) {
    return function (scope, element, attrs) {
        scope.$watch(
            function (scope) {
                // watch the 'clickableCmsContent' expression for changes
                return scope.$eval(attrs.clickableCmsContent);
            },
            function (value) {
                // when the 'clickableCmsContent' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
            }
        );
    };
}

module.exports = clickableCmsContentDirective;